import _get from 'lodash/get';
import { fetchJSON } from '@bonnet/core/fetch';
import buildVdpUrl from '../utilities/buildVdpUrl/buildVdpUrl.js';
var ownerDetailsFetcher = function () {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async vin => {
    const options = {
      circuitBreaker: {
        id: 'walletOwnerDetails',
        timeout: 3000,
        resetTimeout: 30000,
        fallback: {}
      },
      headers: {
        'X-fwd-svc': 'atc'
      },
      query: {
        collapseFilters: true
      },
      ...config.options
    };
    try {
      const res = await fetchJSON(`${config.hostname || ''}/rest/lsc/listing/vin/${vin}`, options);
      const owner = _get(res, 'owners[0]', {});
      const listing = _get(res, 'listings[0]', {});
      if (!listing.vdpBaseUrl) {
        listing.vdpBaseUrl = await buildVdpUrl(listing.id);
      }
      return {
        owner,
        listing
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching owner details: ', error);
    }
    return null;
  };
};
export { ownerDetailsFetcher as default };
